(function (window, document) {
  'use strict';

  var app = window.MNBListing;
  if (!app || typeof app.register !== 'function') return;

  var OTHER_BRAND_VALUE = '__other__';
  var ASSISTED_FAMILY_VALUE = '__assist__';
  var ASSISTED_LABEL = 'Help me find my bike';
  var MODEL_OTHER_VALUE = '__model_other__';
  var YEAR_NOT_SURE_VALUE = '__year_not_sure__';
  var SIZE_OTHER_VALUE = '__size_other__';
  var CURRENT_YEAR = new Date().getFullYear();
  var MIN_LISTED_YEAR = 1990;
  var MIN_LISTING_PRICE = 135;
  var CURRENCY_TO_GBP = { GBP: 1, USD: 0.74, EUR: 0.87 };
  var DEFAULT_MULTIPLIER = 0.95;
  var GRADING = {
    'As good as new': [65.8, 57.9, 54.4, 49.1, 43.9, 38.6, 33.3, 29.8, 26.3, 22.8, 19.3],
    'Good condition': [57.9, 51, 47.9, 43.2, 38.6, 34, 29.3, 26.2, 23.2, 20.1, 17],
    'Needs some work': [47.4, 41.7, 39.1, 35.4, 31.6, 27.8, 24, 21.5, 19, 16.4, 13.9]
  };

  // BikeSpecificationsSection.tsx renders a DIFFERENT subcategory option set
  // per bike type (and one Electric set), so the Ink port repopulates the
  // single static subcategory select at runtime instead of showing every group
  // at once.
  var SUBCATEGORY_LISTS = {
    Electric: ['Electric Road', 'Electric Mountain', 'Electric Hybrid', 'Electric Urban', 'Electric Folding'],
    Road: ['Endurance', 'Aero', 'Race', 'Gravel', 'Triathlon', 'Cyclocross', 'Touring'],
    Mountain: ['Trail', 'Crosscountry', 'Enduro', 'Downhill'],
    Urban: ['Hybrid', 'Folding', 'Commuter', 'Fitness'],
    Youth: ['Balance (no pedals)', 'Kids Mountain', 'Kids Road', 'Kids Hybrid', 'Kids BMX']
  };

  var root = null;
  var store = null;
  var config = {};
  var integrations = { capture: function () {} };
  var brands = [];
  var families = [];
  var allModels = [];
  var selectedFamilyId = null;
  var years = [];
  var bikeModel = null;
  var modelToken = null;
  var yearToken = null;
  var pricingDefaultAssigned = false;
  var unsubscribe = null;
  var boundRoot = null;
  var resumePromise = null;
  var catalogueGeneration = 0;
  var rrpStepVisible = false;
  var rrpStepGeneration = null;
  // When a catalogue lookup for a selection is still in flight we don't yet
  // know whether our own data supplies the RRP, so the RRP step is held until
  // it settles (see renderIdentificationSteps). Set false by beginCatalogueChange
  // and true once a /models/ or /years/ response has been applied (or it's the
  // manual path / there's no catalogue to consult).
  var rrpResolved = false;

  function normalizeAluminium(value) {
    return value === 'Aluminum' ? 'Aluminium' : value;
  }

  function toTitleCase(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  function normalizeModelNames(models) {
    var casings = new Map();
    var resolved = new Map();
    if (!models.length) return models;

    models.forEach(function (entry) {
      String(entry.model || '').split(' ').forEach(function (token) {
        var key = token.toLowerCase();
        if (!casings.has(key)) casings.set(key, new Set());
        casings.get(key).add(token);
      });
    });

    casings.forEach(function (variants, key) {
      resolved.set(key, variants.size === 1 ? variants.values().next().value : toTitleCase(key));
    });

    return models.map(function (entry) {
      var clone = Object.assign({}, entry);
      clone.model = String(entry.model || '').split(' ').map(function (token) {
        return resolved.get(token.toLowerCase()) || token;
      }).join(' ');
      return clone;
    });
  }

  function apiFetch(path) {
    var headers = {};
    if (path.indexOf('/models/') === 0 && modelToken) headers['X-Next-Token'] = modelToken;
    if (path.indexOf('/years/') === 0 && yearToken) headers['X-Next-Token'] = yearToken;

    return fetch(String(config.bikeDataUrl || '') + path, { headers: headers }).then(function (res) {
      var next = res.headers && res.headers.get ? res.headers.get('X-Next-Token') : null;
      var echoed = res.headers && res.headers.get ? res.headers.get('X-Token') : null;
      if (path.indexOf('/brands/') === 0) modelToken = next || null;
      if (path.indexOf('/models/') === 0) {
        yearToken = next || null;
        if (echoed) modelToken = echoed;
      }
      if (path.indexOf('/years/') === 0 && echoed) yearToken = echoed;
      return res;
    });
  }

  function logFailure(label, error) {
    if (window.console && typeof window.console.error === 'function') {
      window.console.error(label, error);
    }
  }

  function formatPrice(price) {
    return '£' + Math.round(price).toLocaleString('en-GB');
  }

  function calculateSuggestedPrice(year, condition, rrp, currentYear) {
    var table = GRADING[condition];
    var age;
    if (rrp == null || rrp <= 0 || !table) return null;
    age = (currentYear || CURRENT_YEAR) - year;
    if (age < 0) return null;
    return Math.round(rrp * (table[Math.min(age, 10)] / 100) * 100) / 100;
  }

  function currentState() {
    return store ? store.get() : {};
  }

  function patch(values) {
    if (store) store.patch(values);
  }

  // Every seller-driven catalogue change bumps this. A boot resume that is still
  // walking the catalogue compares the counter it captured and abandons its result
  // rather than writing a previous bike over the one the seller just picked.
  function beginCatalogueChange() {
    catalogueGeneration += 1;
    rrpResolved = false;
  }

  function resetBikeDataFields(values) {
    Object.keys(app.blankForm || {}).forEach(function (key) {
      if (key.indexOf('bike_data_') === 0) values[key] = app.blankForm[key];
    });
  }

  function resetTemplateBikeState(values) {
    resetBikeDataFields(values);
    values.BikeSizing = '';
    values.internal_bike_has_size_guide = false;
    values.internal_electric_bike = '';
    values.internal_user_edited_price = false;
    bikeModel = null;
  }

  // Wipes the year and everything revealed after it. Condition and the asking
  // price belong to the bike that was just swapped out, so they go too — the
  // price step reveals off state.condition and would otherwise float alone
  // above the hidden condition field after a brand/model change.
  function clearYear() {
    var values = {
      BikeYear: '',
      bike_slug_year: '',
      internal_year_not_sure: false,
      condition: '',
      ListingPrice: ''
    };
    years = [];
    resetTemplateBikeState(values);
    patch(values);
    render();
  }

  function clearModel() {
    selectedFamilyId = null;
    allModels = allModels || [];
    patch({ Model: '', bike_slug_model: '' });
    clearYear();
  }

  function clearBrand() {
    families = [];
    allModels = [];
    selectedFamilyId = null;
    modelToken = null;
    yearToken = null;
    patch({ Brand: '', bike_slug_brand: '', bike_identification_family: '' });
    clearModel();
  }

  function slugForBrandName(name) {
    var wanted = String(name || '').toLowerCase();
    return brands.find(function (brand) {
      return String(brand.name || '').toLowerCase() === wanted || String(brand.slug || '').toLowerCase() === wanted;
    });
  }

  function modelEntryForName(name) {
    var wanted = String(name || '').toLowerCase();
    return allModels.find(function (model) {
      return String(model.model || '').toLowerCase() === wanted || String(model.modelSlug || '').toLowerCase() === wanted;
    });
  }

  function filteredModels() {
    if (selectedFamilyId === null || selectedFamilyId === undefined || selectedFamilyId === '') return allModels.slice();
    return allModels.filter(function (model) {
      return String(model.familyId || '') === String(selectedFamilyId);
    });
  }

  function sortedModels() {
    return filteredModels().sort(function (a, b) {
      return String(a.model || '').localeCompare(String(b.model || ''));
    });
  }

  function allYears(apiYears) {
    var result = new Set();
    var year;
    for (year = CURRENT_YEAR + 1; year >= MIN_LISTED_YEAR; year -= 1) result.add(String(year));
    (apiYears || []).forEach(function (item) {
      result.add(String(item));
    });
    return Array.from(result).sort(function (a, b) {
      return Number(b) - Number(a);
    });
  }

  function extractBatteryCapacity(value) {
    var match = String(value || '').match(/(\d{3,4})\s*wh\b/i);
    if (!match) return '';
    return match[1] + 'Wh';
  }

  function extractGbpRrp(data) {
    var summaries = [
      { price: data.bike_summary_0_price, currency: data.bike_summary_0_currency },
      { price: data.bike_summary_1_price, currency: data.bike_summary_1_currency }
    ].filter(function (summary) {
      return summary.price && summary.currency;
    });
    var gbp = summaries.find(function (summary) {
      return summary.currency === 'GBP';
    });
    var convertible;
    if (gbp) return String(gbp.price);
    convertible = summaries.find(function (summary) {
      return Object.prototype.hasOwnProperty.call(CURRENCY_TO_GBP, summary.currency);
    });
    if (!convertible) return '';
    return String(Math.round(parseFloat(convertible.price) * CURRENCY_TO_GBP[convertible.currency]));
  }

  function applyBikeModelToForm(data) {
    var gbpRrp = extractGbpRrp(data || {});
    patch({
      bike_data_FrameMaterial: normalizeAluminium(data['Frame Material'] || ''),
      bike_data_FrameComponent: data['Frame Component'] || '',
      bike_data_SuspensionType: data['Suspension Type'] || '',
      bike_data_Fork: data.Fork || '',
      bike_data_ForkMaterial: normalizeAluminium(data['Fork Material'] || ''),
      bike_data_ForkAxle: data['Fork Axle'] || '',
      bike_data_ForkOffset: data['Fork Offset'] || '',
      bike_data_ForkSteerer: data['Fork Steerer'] || '',
      bike_data_Drivetrain: data.Drivetrain || '',
      bike_data_Groupset: data.Groupset || '',
      bike_data_Shifting: data.Shifting || '',
      bike_data_RearDerailleur: data['Rear Derailleur'] || '',
      bike_data_FrontDerailleur: data['Front Derailleur'] || '',
      bike_data_Shifters: data.Shifters || '',
      bike_data_Cassette: data.Cassette || '',
      bike_data_Crank: data.Crank || '',
      bike_data_BottomBracket: data['Bottom Bracket'] || '',
      bike_data_Chain: data.Chain || '',
      bike_data_ChainGuide: data['Chain Guide'] || '',
      bike_data_Rims: data.Rims || '',
      bike_data_Wheelset: data.Rims || '',
      bike_data_RimWidth: data['Rim Width'] || '',
      bike_data_RimDriver: data['Rim Driver'] || '',
      bike_data_Spokes: data.Spokes || '',
      bike_data_FrontHub: data['Front Hub'] || '',
      bike_data_RearHub: data['Rear Hub'] || '',
      bike_data_Tires: data.Tires || '',
      bike_data_TireSize: data['Tire Size'] || '',
      bike_data_TireCompound: data['Tire Compound'] || '',
      bike_data_TireTubeless: data['Tire Tubeless'] || '',
      bike_data_Brakes: data.Brakes || '',
      bike_data_BrakeType: data['Brake Type'] || '',
      bike_data_BrakePistons: data['Brake Pistons'] || '',
      bike_data_Handlebar: data.Handlebar || '',
      bike_data_HandlebarWidth: data['Handlebar Width'] || '',
      bike_data_HandlebarRise: data['Handlebar Rise'] || '',
      bike_data_HandlebarSweep: data['Handlebar Sweep'] || '',
      bike_data_Stem: data.Stem || '',
      bike_data_Headset: data.Headset || '',
      bike_data_Grips: data.Grips || '',
      bike_data_Saddle: data.Saddle || '',
      bike_data_Seatpost: data.Seatpost || '',
      bike_data_Pedals: data.Pedals || '',
      bike_data_Remote: data.Remote || '',
      bike_data_Charger: data.Charger || '',
      bike_data_Gender: data.Gender || 'unisex',
      bike_data_Weight: data.Weight || '',
      bike_data_Subcategory: data.Subcategory || '',
      bike_data_Name: data.Model_Name || '',
      bike_data_RearShock: data['Rear Shock'] || '',
      bike_data_SeatpostType: data['Seatpost Type'] || '',
      bike_data_TravelFront: data['Travel Front'] || '',
      bike_data_TravelRear: data['Travel Rear'] || '',
      bike_data_WheelSize: data['Wheel Size'] || '',
      bike_data_WheelMaterial: normalizeAluminium(data['Wheel Material'] || ''),
      bike_data_Battery: data.Battery || '',
      bike_data_BatteryCapacity: extractBatteryCapacity(data.Battery || ''),
      bike_data_Motor: data.Motor || '',
      bike_data_Year: data.Year || '',
      bike_data_Category: data.Category || '',
      bike_data_Rrp: gbpRrp,
      bike_data_RrpGBP: gbpRrp,
      internal_electric_bike: data.Motor && String(data.Motor).trim() ? 'Yes' : 'No',
      internal_bike_has_size_guide: Object.keys(data.sizeGuide || {}).length > 0
    });
  }

  // The assisted flow is the only identification flow there is, so the escape
  // hatch label is no longer conditional. `state.internal_assisted_identification`
  // is a different thing: it records that this particular seller entered the
  // assisted path rather than picking a brand from the catalogue.
  function fallbackLabel() {
    return ASSISTED_LABEL;
  }

  function loadBrands() {
    if (brands.length) return Promise.resolve(brands);
    if (!config.brandsUrl) return Promise.resolve([]);
    setSelectLoading('[data-brand-select]', true);
    return Promise.resolve(fetch(config.brandsUrl)).then(function (res) {
      if (!res || !res.ok) return [];
      return res.json();
    }).then(function (data) {
      brands = Array.isArray(data) ? data : [];
      render();
      return brands;
    }).catch(function (error) {
      logFailure('Error fetching bike brands:', error);
      brands = [];
      render();
      return brands;
    }).finally(function () {
      setSelectLoading('[data-brand-select]', false);
    });
  }

  function selectBrand(name) {
    beginCatalogueChange();
    return loadBrands().then(function () {
      var brand = slugForBrandName(name);
      var values;
      families = brand && Array.isArray(brand.families) ? brand.families.slice() : [];
      allModels = [];
      selectedFamilyId = null;
      years = [];
      bikeModel = null;
      modelToken = null;
      yearToken = null;
      values = {
        Brand: name,
        Model: '',
        BikeYear: '',
        BikeSizing: '',
        condition: '',
        ListingPrice: '',
        bike_slug_brand: brand ? brand.slug : '',
        bike_slug_model: '',
        bike_slug_year: '',
        internal_year_not_sure: false,
        internal_listWithoutTemplate: false,
        internal_assisted_identification: false,
        internal_assisted_identification_entry_point: '',
        bike_identification_family: '',
        internal_bike_has_size_guide: false,
        internal_user_edited_price: false
      };
      resetBikeDataFields(values);
      patch(values);
      if (!brand) {
        render();
        return [];
      }

      render();
      setSelectLoading('[data-model-select]', true);
      return apiFetch('/brands/' + brand.slug).then(function (res) {
        if (!res.ok) return { models: [] };
        return res.json();
      }).then(function (data) {
        allModels = normalizeModelNames(Array.isArray(data.models) ? data.models : []);
        render();
        return allModels;
      }).catch(function (error) {
        logFailure('Error fetching brand models:', error);
        allModels = [];
        render();
        return allModels;
      }).finally(function () {
        setSelectLoading('[data-model-select]', false);
      });
    });
  }

  function selectFamily(familyId) {
    var family = families.find(function (item) {
      return String(item.familyId) === String(familyId);
    });
    beginCatalogueChange();
    selectedFamilyId = familyId;
    patch({
      Model: '',
      bike_slug_model: '',
      bike_identification_family: family ? String(family.family || '') : ''
    });
    clearYear();
    render();
  }

  function selectModel(name) {
    var entry = modelEntryForName(name);
    var state = currentState();
    if (!entry || !state.bike_slug_brand) return Promise.resolve([]);
    beginCatalogueChange();
    years = [];
    bikeModel = null;
    patch({
      Model: entry.model,
      BikeYear: '',
      BikeSizing: '',
      bike_slug_model: entry.modelSlug,
      bike_slug_year: '',
      internal_year_not_sure: false,
      internal_listWithoutTemplate: false,
      internal_bike_has_size_guide: false
    });
    clearYear();
    patch({ Model: entry.model, bike_slug_model: entry.modelSlug, internal_listWithoutTemplate: false });
    render();
    setSelectLoading('[data-year-select]', true);
    return apiFetch('/models/' + state.bike_slug_brand + '/' + entry.modelSlug).then(function (res) {
      if (!res.ok) return { years: [] };
      return res.json();
    }).then(function (data) {
      years = allYears(Array.isArray(data.years) ? data.years : []);
      render();
      return years;
    }).catch(function (error) {
      logFailure('Error fetching model years:', error);
      years = [];
      render();
      return years;
    }).finally(function () {
      setSelectLoading('[data-year-select]', false);
    });
  }

  function selectYear(year) {
    var state = currentState();
    var values;
    beginCatalogueChange();
    if (!state.bike_slug_brand || !state.bike_slug_model) {
      values = { BikeYear: String(year), bike_slug_year: '', internal_year_not_sure: false };
      resetTemplateBikeState(values);
      rrpResolved = true;
      patch(values);
      render();
      return Promise.resolve(null);
    }
    values = { BikeYear: String(year), bike_slug_year: String(year), internal_year_not_sure: false };
    resetTemplateBikeState(values);
    patch(values);
    render();
    return apiFetch('/years/' + state.bike_slug_brand + '/' + state.bike_slug_model + '/' + year).then(function (res) {
      if (!res.ok) {
        logFailure('Error fetching bike model data:', new Error('Bike model request failed with status ' + res.status));
        return null;
      }
      return res.json();
    }).then(function (data) {
      bikeModel = data || null;
      rrpResolved = true;
      if (bikeModel) applyBikeModelToForm(bikeModel);
      render();
      updatePricingInputs();
      return bikeModel;
    }).catch(function (error) {
      logFailure('Error fetching bike model data:', error);
      values = { BikeYear: String(year), bike_slug_year: String(year), internal_year_not_sure: false };
      resetTemplateBikeState(values);
      rrpResolved = true;
      patch(values);
      render();
      return null;
    });
  }

  function fetchJson(path, fallback) {
    return apiFetch(path).then(function (res) {
      if (!res.ok) return fallback;
      return res.json();
    });
  }

  // BikeModelSelect.tsx runs its brand/model/year effects on mount, so a restored
  // draft or a hydrated valuation URL re-walks the catalogue with no user input:
  // slugs resolve to display names, the model/year lists repopulate, the template
  // is applied, and PricingSection seeds the asking price.
  //
  // The walk is four requests long and the form is interactive throughout, so every
  // step re-checks that the state it is resolving is still the state on screen. If
  // the seller has corrected the brand, model or year in the meantime the resume
  // abandons its result instead of writing the previous bike back over their choice.
  function resumeFromState() {
    var state = currentState();
    var wantedBrand = state.bike_slug_brand || state.Brand;
    var wantedModel = state.bike_slug_model || state.Model;
    var wantedYear = String(state.BikeYear || '');
    var rrpOverride = String(state.bike_data_Rrp || state.bike_data_RrpGBP || '');
    var generation = catalogueGeneration;

    function stale(expected) {
      var now;
      if (catalogueGeneration !== generation) return true;
      now = currentState();
      if (String(now.bike_slug_brand || now.Brand || '') !== String(expected.brand || '')) return true;
      if ('model' in expected && String(now.bike_slug_model || now.Model || '') !== String(expected.model || '')) return true;
      if ('year' in expected && String(now.BikeYear || '') !== String(expected.year || '')) return true;
      return false;
    }

    // Only re-render when the resume was abandoned by a plain state change
    // rather than by a newer catalogue request already owning the render.
    function abandon() {
      if (catalogueGeneration === generation) render();
      return null;
    }

    return loadBrands().then(function () {
      var brand;
      if (stale({ brand: wantedBrand, model: wantedModel, year: wantedYear })) return abandon();
      brand = wantedBrand && (state.internal_listWithoutTemplate !== true || state.internal_assisted_identification === true)
        ? slugForBrandName(wantedBrand)
        : null;
      if (!brand) {
        render();
        updatePricingInputs();
        return null;
      }
      families = Array.isArray(brand.families) ? brand.families.slice() : [];
      if (state.bike_identification_family) {
        var restoredFamily = families.find(function (family) {
          return String(family.family || '').toLowerCase() === String(state.bike_identification_family).toLowerCase();
        });
        selectedFamilyId = restoredFamily ? restoredFamily.familyId : null;
      }
      patch({ Brand: brand.name, bike_slug_brand: brand.slug });
      render();

      return fetchJson('/brands/' + brand.slug, { models: [] }).then(function (data) {
        var entry;
        if (stale({ brand: brand.slug, model: wantedModel, year: wantedYear })) return abandon();
        allModels = normalizeModelNames(Array.isArray(data.models) ? data.models : []);
        render();
        entry = wantedModel ? modelEntryForName(wantedModel) : null;
        if (!entry) {
          updatePricingInputs();
          return null;
        }
        selectedFamilyId = entry.familyId || null;
        patch({ Model: entry.model, bike_slug_model: entry.modelSlug });
        render();

        return fetchJson('/models/' + brand.slug + '/' + entry.modelSlug, { years: [] }).then(function (modelData) {
          if (stale({ brand: brand.slug, model: entry.modelSlug, year: wantedYear })) return abandon();
          years = allYears(Array.isArray(modelData.years) ? modelData.years : []);
          patch({ BikeYear: wantedYear });
          if (!wantedYear) {
            if (state.internal_year_not_sure === true) rrpResolved = true;
            render();
            updatePricingInputs();
            return null;
          }
          render();

          return fetchJson('/years/' + brand.slug + '/' + entry.modelSlug + '/' + wantedYear, null).then(function (yearData) {
            var restore = {};
            if (stale({ brand: brand.slug, model: entry.modelSlug, year: wantedYear })) return abandon();
            bikeModel = yearData || null;
            rrpResolved = true;
            if (bikeModel) applyBikeModelToForm(bikeModel);
            // useUrlParamHydration.ts:92-97 re-applies the URL RRP after the
            // catalogue overwrites bike_data_Rrp.
            if (rrpOverride) {
              restore.bike_data_Rrp = rrpOverride;
              restore.bike_data_RrpGBP = rrpOverride;
            }
            restore.BikeYear = wantedYear;
            restore.bike_slug_year = wantedYear;
            if (state.BikeSizing) restore.BikeSizing = state.BikeSizing;
            patch(restore);
            render();
            updatePricingInputs();
            return bikeModel;
          });
        });
      });
    }).catch(function (error) {
      logFailure('Error restoring bike catalogue:', error);
      rrpResolved = true;
      render();
      updatePricingInputs();
      return null;
    });
  }

  function focusAssistedType() {
    window.setTimeout(function () {
      var firstChoice = root && root.querySelector('[data-assisted-step="type"] input');
      if (firstChoice) firstChoice.focus();
    }, 0);
  }

  function exitAssistedIdentification() {
    var state = currentState();
    var nextFocus;
    patch({
      internal_listWithoutTemplate: false,
      internal_assisted_identification: false,
      internal_assisted_identification_entry_point: '',
      internal_electric_bike: '',
      BikeType: '',
      bike_identification_frame_text: '',
      bike_identification_age_range: '',
      bike_identification_price_band: ''
    });
    render();
    if (state.Brand) {
      nextFocus = families.length > 0 && selectedFamilyId === null
        ? root.querySelector('[data-bike-family] .nl-command-trigger')
        : root.querySelector('[data-model-select] .nl-command-trigger');
    } else {
      nextFocus = root.querySelector('[data-brand-select] .nl-command-trigger');
    }
    if (nextFocus && typeof nextFocus.focus === 'function') nextFocus.focus();
  }

  function focusSizeOther() {
    var input = root && root.querySelector('[data-size-other-input]');
    if (input && typeof input.focus === 'function') input.focus();
  }

  function manualBrand(value) {
    var trimmed = String(value || '').trim();
    var wasManual = currentState().internal_listWithoutTemplate === true;
    var values;
    return loadBrands().then(function () {
      if (trimmed && slugForBrandName(trimmed)) return selectBrand(trimmed);
      beginCatalogueChange();
      clearBrand();
      values = {
        Brand: trimmed,
        internal_listWithoutTemplate: true,
        internal_electric_bike: wasManual ? (currentState().internal_electric_bike || 'No') : 'No'
      };
      if (!wasManual) {
        values.ListingPrice = '';
        values.bike_data_SuggestedPrice = '';
        values.internal_user_edited_price = false;
      }
      patch(values);
      render();
      return undefined;
    });
  }

  function manualModel(value) {
    var wasManual = currentState().internal_listWithoutTemplate === true;
    var electricAnswer = wasManual ? currentState().internal_electric_bike : 'No';
    beginCatalogueChange();
    clearModel();
    patch({
      Model: String(value || '').trim(),
      internal_listWithoutTemplate: true,
      internal_electric_bike: electricAnswer || 'No'
    });
    render();
  }

  function manualYear(value) {
    var wasManual = currentState().internal_listWithoutTemplate === true;
    var electricAnswer = wasManual ? currentState().internal_electric_bike : 'No';
    beginCatalogueChange();
    var values = {
      BikeYear: String(value || '').trim(),
      bike_slug_year: '',
      internal_year_not_sure: false,
      internal_listWithoutTemplate: true
    };
    resetTemplateBikeState(values);
    values.internal_electric_bike = electricAnswer || 'No';
    patch(values);
    render();
  }

  function selectYearNotSure() {
    beginCatalogueChange();
    var values = {
      BikeYear: '',
      bike_slug_year: '',
      internal_year_not_sure: true
    };
    resetTemplateBikeState(values);
    rrpResolved = true;
    patch(values);
    render();
    updatePricingInputs();
  }

  function manualSize(value) {
    beginCatalogueChange();
    patch({ BikeSizing: sizeKeyFromLabel(value), internal_listWithoutTemplate: true });
    render();
  }

  function sizeKeyFromLabel(value) {
    var label = String(value || '').trim();
    var guide = bikeModel && bikeModel.sizeGuide ? bikeModel.sizeGuide : {};
    var key = Object.keys(guide).find(function (item) {
      return label === item || label.indexOf(item + ' (') === 0;
    });
    return key || label;
  }

  function sizeOptions() {
    var guide = bikeModel && bikeModel.sizeGuide ? bikeModel.sizeGuide : {};
    return Object.keys(guide).map(function (key) {
      var entry = guide[key] || {};
      if (entry.minHeight && entry.maxHeight) return key + ' (' + entry.minHeight + '–' + entry.maxHeight + ')';
      return key;
    });
  }

  function setListingPrice(value, source) {
    // No analytics event here: PricingSection.tsx emits nothing on price edits,
    // and the plan pins the PostHog event set to the React source.
    patch({
      ListingPrice: String(value),
      internal_user_edited_price: source === 'seller'
    });
    renderPricing();
  }

  function updatePricingInputs(values) {
    var state;
    var year;
    var rrp;
    var suggested;
    var formatted;
    var seeded;
    if (values) patch(values);
    state = currentState();
    year = parseInt(state.BikeYear, 10);
    rrp = parseFloat(state.bike_data_Rrp || state.bike_data_RrpGBP);
    suggested = calculateSuggestedPrice(year, state.condition, rrp);
    formatted = suggested !== null ? formatPrice(suggested) : '';
    patch({
      bike_data_SuggestedPrice: formatted,
      internal_pricing_default_variant: 'default'
    });
    if (!pricingDefaultAssigned) {
      integrations.capture('pricing_default_assigned', { variant: 'default', multiplier: DEFAULT_MULTIPLIER });
      pricingDefaultAssigned = true;
    }
    if (suggested !== null && currentState().internal_user_edited_price !== true) {
      seeded = Math.max(MIN_LISTING_PRICE, Math.round(suggested * DEFAULT_MULTIPLIER));
      patch({ ListingPrice: String(seeded), internal_user_edited_price: false });
    }
    renderPricing();
    return suggested;
  }

  // internal_listWithoutTemplate is the manual-path flag the rest of the form
  // already keys off; a seller is in "custom brand" mode as soon as they pick
  // Other, even before they have typed a name.
  function isCustomBrand(state) {
    return state.internal_listWithoutTemplate === true && !slugForBrandName(state.Brand || '');
  }

  // A manual bike never has a real model list to search (sortedModels() is
  // always empty without a catalogue brand), so it goes straight to the
  // reveal input instead of making the seller open an empty list first.
  function isCustomModel(state) {
    return state.internal_listWithoutTemplate === true &&
      (sortedModels().length === 0 || !modelEntryForName(state.Model || ''));
  }

  function isCustomYear(state) {
    return state.internal_year_not_sure !== true && state.internal_listWithoutTemplate === true &&
      (years.length === 0 || years.indexOf(String(state.BikeYear || '')) === -1);
  }

  function isCustomSize(state) {
    var guide = bikeModel && bikeModel.sizeGuide ? bikeModel.sizeGuide : {};
    return state.internal_listWithoutTemplate === true &&
      (Object.keys(guide).length === 0 || !Object.prototype.hasOwnProperty.call(guide, state.BikeSizing || ''));
  }

  // BikeSpecificationsSection.tsx:20-21 (showSizeSelector): once it's clear the
  // bike has no per-model size guide to pick from — manual listing or not —
  // the seller answers with the plain standard-size dropdown instead.
  function hasSizeGuide() {
    var guide = bikeModel && bikeModel.sizeGuide ? bikeModel.sizeGuide : {};
    return Object.keys(guide).length > 0;
  }

  function modelSelectOptions() {
    return sortedModels().map(function (entry) {
      return { value: entry.model, label: entry.model };
    }).concat([{ value: MODEL_OTHER_VALUE, label: ASSISTED_LABEL, alwaysVisible: true }]);
  }

  function yearSelectOptions() {
    return [{ value: YEAR_NOT_SURE_VALUE, label: 'Not sure' }].concat(years.map(function (year) {
      return { value: String(year), label: String(year) };
    }));
  }

  function sizeGuideOptions() {
    var guide = bikeModel && bikeModel.sizeGuide ? bikeModel.sizeGuide : {};
    return Object.keys(guide).map(function (key) {
      var entry = guide[key] || {};
      var label = entry.minHeight && entry.maxHeight ? key + ' (' + entry.minHeight + '–' + entry.maxHeight + ')' : key;
      return { value: key, label: label };
    });
  }

  function sizeSelectOptions() {
    return sizeGuideOptions().concat([{ value: SIZE_OTHER_VALUE, label: 'My size isn’t listed', alwaysVisible: true }]);
  }

  // Mirrors the loadingModels/loadingYears flags in BikeModelSelect.tsx: while
  // a catalogue fetch is in flight the corresponding picker shows a skeleton
  // (nl-command-select loading state) instead of its label. Native selects
  // have no skeleton, so they are disabled for the duration instead. Setting
  // .loading is a no-op on an un-upgraded element, hence the setOptions guard.
  function setSelectLoading(selector, loading) {
    var select = root && root.querySelector(selector);
    if (!select) return;
    if (typeof select.setOptions === 'function') {
      select.loading = !!loading;
      return;
    }
    if (loading) select.setAttribute('disabled', '');
    else select.removeAttribute('disabled');
  }

  function renderModelSelect(state) {
    var select = root && root.querySelector('[data-model-select]');
    if (!select || typeof select.setOptions !== 'function') return;
    select.setOptions(modelSelectOptions());
    select.value = isCustomModel(state) ? MODEL_OTHER_VALUE : (state.Model || '');
  }

  function renderModelOther(state) {
    var wrapper = root && root.querySelector('[data-model-other]');
    var input = root && root.querySelector('[data-model-other-input]');
    var custom = state.internal_assisted_identification !== true && isCustomModel(state);
    if (!wrapper) return;
    wrapper.hidden = !custom;
    if (input && document.activeElement !== input && input.value !== (state.Model || '')) {
      input.value = custom ? (state.Model || '') : '';
    }
  }

  function renderYearSelect(state) {
    var select = root && root.querySelector('[data-year-select]');
    if (!select || typeof select.setOptions !== 'function') return;
    select.setOptions(yearSelectOptions());
    select.value = state.internal_year_not_sure === true
      ? YEAR_NOT_SURE_VALUE
      : (state.BikeYear || '');
  }

  function renderYearOther(state) {
    var wrapper = root && root.querySelector('[data-year-other]');
    var input = root && root.querySelector('[data-year-other-input]');
    var custom = state.internal_assisted_identification !== true && isCustomYear(state);
    if (!wrapper) return;
    wrapper.hidden = !custom;
    if (input && document.activeElement !== input && input.value !== (state.BikeYear || '')) {
      input.value = custom ? (state.BikeYear || '') : '';
    }
  }

  function renderSizeSelect(state) {
    var select = root && root.querySelector('[data-size-select]');
    if (!select || typeof select.setOptions !== 'function') return;
    select.setOptions(sizeSelectOptions());
    select.value = isCustomSize(state) ? SIZE_OTHER_VALUE : (state.BikeSizing || '');
  }

  function renderSizeOther(state) {
    var wrapper = root && root.querySelector('[data-size-other]');
    var input = root && root.querySelector('[data-size-other-input]');
    var custom = state.internal_assisted_identification !== true && isCustomSize(state);
    if (!wrapper) return;
    wrapper.hidden = !custom;
    if (input && document.activeElement !== input && input.value !== (state.BikeSizing || '')) {
      input.value = custom ? (state.BikeSizing || '') : '';
    }
  }

  // BikeSpecificationsSection.tsx:21 (showSizeSelector = isManualPath || !hasSizeGuide):
  // a manual listing, or a catalogue model with no sizeGuide at all, answers
  // BikeSizing with the plain standard-size list instead of a guide-driven pick.
  function renderGenericSizeSelect(state) {
    var wrapper = root && root.querySelector('[data-generic-size]');
    var select = root && root.querySelector('[data-generic-size-select]');
    var visible = state.internal_listWithoutTemplate === true || !hasSizeGuide();
    if (!wrapper) return;
    wrapper.hidden = !visible;
    if (select && document.activeElement !== select) select.value = visible ? (state.BikeSizing || '') : '';
  }

  // BikeSpecificationsSection.tsx shows a DIFFERENT subcategory list per bike
  // type (and an Electric one when the seller answers electric Yes), so the
  // port repopulates the single static subcategory select at runtime. The
  // select only exists on the manual path, and a stale choice is cleared when
  // the seller swaps type, mirroring the React flow which swaps option sets.
  function subcategoryOptionsFor(state) {
    var bikeType = String(state.BikeType || '');
    var electric = bikeType === 'Electric' || String(state.internal_electric_bike || '') === 'Yes';
    var list = electric ? SUBCATEGORY_LISTS.Electric : (SUBCATEGORY_LISTS[bikeType] || []);
    return list.map(function (label) {
      return { value: label, label: label };
    });
  }

  function renderSubcategorySelect(state) {
    var select = root && root.querySelector('[data-subcategory-select]');
    var options;
    var current;
    var belongs;
    if (state.internal_listWithoutTemplate !== true) return;
    if (!select || typeof select.setOptions !== 'function') return;
    options = subcategoryOptionsFor(state);
    select.setOptions(options);
    current = String(state.bike_data_Subcategory || '');
    belongs = options.some(function (option) {
      return option.value === current;
    });
    if (!belongs && current) {
      patch({ bike_data_Subcategory: '' });
      select.value = '';
    } else {
      select.value = belongs ? current : '';
    }
  }

  // Brand gets a real <select> like every other field on this page instead
  // of a text input plus datalist, which is unreliable across browsers and
  // reads nothing like the rest of the form. The selected option is derived
  // from state, not preserved DOM state, so a restored draft with a
  // not-in-catalogue brand still lands on "Help me find my bike" rather than
  // a blank select.
  function renderBrandSelect(state) {
    var select = root && root.querySelector('[data-brand-select]');
    if (!select) return;
    // The empty-search escape hatch ("Help me find my bike") is part of the
    // assisted flow, which is now unconditional, so the markup's attributes are
    // left in place and an unmatched search offers the assisted path.
    select.setOptions(brands.map(function (brand) {
      return { value: brand.name, label: brand.name };
    }).concat([{ value: OTHER_BRAND_VALUE, label: fallbackLabel(), alwaysVisible: true }]));

    if (isCustomBrand(state)) select.value = OTHER_BRAND_VALUE;
    else if (state.Brand && slugForBrandName(state.Brand)) select.value = state.Brand;
    else select.value = '';
  }

  function renderBrandOther(state) {
    var wrapper = root && root.querySelector('[data-brand-other]');
    var input = root && root.querySelector('[data-brand-other-input]');
    var custom = state.internal_assisted_identification !== true && isCustomBrand(state);
    if (!wrapper) return;
    wrapper.hidden = !custom;
    // Not a data-field control (see the "Two Bridges"-style split from the
    // select above), so it needs its own state-to-DOM sync on restore.
    if (input && document.activeElement !== input && input.value !== (state.Brand || '')) {
      input.value = custom ? (state.Brand || '') : '';
    }
  }

  // Model family gets a real <select>, same reasoning as renderBrandSelect: a
  // text input plus datalist is unreliable across browsers and doesn't read
  // like the rest of the form.
  function renderFamilySelect(state) {
    var select = root && root.querySelector('[data-bike-family]');
    var brandName = String(state && state.Brand || '').trim();
    var list;
    if (!select) return;
    select.setAttribute('empty-search-message', brandName ? 'No ' + brandName + ' ranges match' : 'No ranges match');
    select.setAttribute('empty-search-description', 'It may be written differently on the bike.');
    select.setAttribute('empty-search-action', ASSISTED_LABEL);
    select.setAttribute('empty-search-action-value', ASSISTED_FAMILY_VALUE);
    list = families.map(function (family) {
      return { value: String(family.familyId), label: family.family };
    });
    list.push({ value: ASSISTED_FAMILY_VALUE, label: ASSISTED_LABEL, alwaysVisible: true });
    select.setOptions(list);

    if (selectedFamilyId === null) select.value = '';
    else if (selectedFamilyId === '') select.value = 'Other';
    else select.value = String(selectedFamilyId);
  }

  function renderPricing() {
    var state = currentState();
    var suggestedNumber = parseFloat(String(state.bike_data_SuggestedPrice || '').replace(/[^0-9.]/g, ''));
    var listingPrice = parseFloat(state.ListingPrice || '0');
    var widget = root && root.querySelector('[data-price-grade-widget]');
    if (!widget) return;
    widget.hidden = state.internal_assisted_identification === true;
    widget.setAttribute('listing-price', isNaN(listingPrice) ? '0' : String(listingPrice));
    widget.setAttribute('suggested-price', isNaN(suggestedNumber) ? '0' : String(suggestedNumber));
  }

  // Mirrors the progressive reveal in the reference form (BikeIdentificationSection.tsx /
  // BikeModelSelect.tsx): each field only appears once the one before it has an answer,
  // so a seller sees Brand alone at first instead of the whole section at once.
  function renderIdentificationSteps(state) {
    var hasFamilies = families.length > 0;
    var familyChosen = !hasFamilies || selectedFamilyId !== null;
    var manual = state.internal_listWithoutTemplate === true;
    var rrpValue = parseFloat(state.bike_data_Rrp || state.bike_data_RrpGBP);
    var hasRrpValue = !isNaN(rrpValue) && rrpValue > 0;
    var yearAnswered = !!state.BikeYear || state.internal_year_not_sure === true;
    // Whether this seller entered the assisted path. That is a per-seller fact,
    // not a switch: sellers who pick their brand from the catalogue answer the
    // catalogue steps instead of the assisted questions.
    var inAssisted = state.internal_assisted_identification === true;
    var assistedWrapper = root.querySelector('[data-assisted-identification]');
    var brandStep = root.querySelector('[data-standard-identification="brand"]');
    var assistedSteps;
    var assistedComplete;
    if (assistedWrapper) assistedWrapper.hidden = !inAssisted;
    if (brandStep) brandStep.hidden = inAssisted;
    assistedSteps = {
      type: inAssisted,
      frame: inAssisted && !!state.BikeType,
      age: inAssisted && !!String(state.bike_identification_frame_text || '').trim(),
      'price-band': inAssisted && !!state.bike_identification_age_range
    };
    assistedComplete = inAssisted && !!state.BikeType &&
      !!String(state.bike_identification_frame_text || '').trim() &&
      !!state.bike_identification_age_range && !!state.bike_identification_price_band;
    Array.prototype.slice.call(root.querySelectorAll('[data-assisted-step]')).forEach(function (node) {
      node.hidden = !assistedSteps[node.getAttribute('data-assisted-step')];
    });
    // We only ask for RRP when our own catalogue data doesn't already supply it
    // (or there's no catalogue match at all, i.e. the manual path). The decision
    // is made once per catalogue selection (beginCatalogueChange bumps
    // catalogueGeneration): typing into the RRP field itself makes hasRrpValue
    // true but must not re-hide the very field the seller is typing into, so
    // once shown for a generation it stays shown. Crucially we DELAY that first
    // decision until the catalogue lookup settles — if we evaluated while the
    // /years/... request was still in flight the question would flash open for
    // bikes whose RRP our data already has, and never re-hide (rrpStepGeneration
    // locks the very first evaluation of a generation).
    var catalogueSettled = manual || rrpResolved;
    if (catalogueSettled) {
      var rrpNeeded = yearAnswered && !hasRrpValue;
      if (catalogueGeneration !== rrpStepGeneration) {
        rrpStepVisible = rrpNeeded;
        rrpStepGeneration = catalogueGeneration;
      } else if (rrpNeeded) {
        rrpStepVisible = true;
      }
    }
    var steps = {
      family: !!state.Brand && hasFamilies && !manual && !inAssisted,
      // The model step shows whenever a family is settled, even with an empty
      // model list: that empty list is itself the cue to take the "Help me find
      // my bike" escape hatch.
      model: !inAssisted && !!state.Brand && familyChosen,
      year: !!state.Model && years.length > 0 && !inAssisted,
      size: !!state.BikeYear && sizeOptions().length > 0 && !inAssisted,
      rrp: rrpStepVisible && !inAssisted,
      condition: inAssisted ? assistedComplete : yearAnswered && (manual || hasRrpValue),
      price: !!state.condition
    };
    Array.prototype.slice.call(root.querySelectorAll('[data-identification-step]')).forEach(function (node) {
      node.hidden = !steps[node.getAttribute('data-identification-step')];
    });
  }

  function render() {
    var state;
    if (!root) return;
    state = currentState();
    renderBrandSelect(state);
    renderBrandOther(state);
    renderFamilySelect(state);
    renderModelSelect(state);
    renderModelOther(state);
    renderYearSelect(state);
    renderYearOther(state);
    renderSizeSelect(state);
    renderSizeOther(state);
    renderGenericSizeSelect(state);
    renderSubcategorySelect(state);
    renderIdentificationSteps(state);
    renderPricing();
  }

  function bindRoot() {
    if (!root || boundRoot === root) return;
    boundRoot = root;

    root.addEventListener('nl-command-select-empty-change', function (event) {
      var target = event.target;
      var footer = root.querySelector('.nl-submit-bar');
      var hidesFooter = target && target.hasAttribute && (
        target.hasAttribute('data-brand-select') || target.hasAttribute('data-bike-family')
      );
      if (!hidesFooter) return;
      if (footer) footer.hidden = !!(event.detail && event.detail.empty);
    });

    root.addEventListener('change', function (event) {
      var target = event.target;
      var field = target && target.getAttribute && target.getAttribute('data-field');
      var value = target && target.value;
      var familyField = target && target.hasAttribute && target.hasAttribute('data-bike-family');
      var family;
      if (target && target.hasAttribute && target.hasAttribute('data-brand-other-input')) {
        manualBrand(target.value);
        return;
      }
      if (target && target.hasAttribute && target.hasAttribute('data-model-other-input')) {
        manualModel(target.value);
        return;
      }
      if (target && target.hasAttribute && target.hasAttribute('data-year-other-input')) {
        manualYear(target.value);
        return;
      }
      if (target && target.hasAttribute && target.hasAttribute('data-size-other-input')) {
        manualSize(target.value);
        return;
      }
      if (!field && !familyField) return;
      if (familyField) {
        if (value === ASSISTED_FAMILY_VALUE) {
          beginCatalogueChange();
          clearYear();
          patch({
            internal_listWithoutTemplate: true,
            internal_assisted_identification_entry_point: 'family',
            internal_assisted_identification: true,
            Model: '',
            BikeYear: '',
            bike_slug_model: '',
            bike_slug_year: ''
          });
          render();
          focusAssistedType();
          return;
        }
        family = families.find(function (item) {
          return item.family === value || String(item.familyId) === value;
        });
        if (family) selectFamily(family.familyId);
        else if (value === 'Other') selectFamily('');
        return;
      }
      if (field === 'Brand' && value === OTHER_BRAND_VALUE) {
        beginCatalogueChange();
        clearBrand();
        patch({
          internal_listWithoutTemplate: true,
          internal_assisted_identification_entry_point: 'brand',
          internal_assisted_identification: true,
          internal_electric_bike: 'No',
          ListingPrice: '',
          bike_data_SuggestedPrice: '',
          internal_user_edited_price: false
        });
        render();
        focusAssistedType();
      } else if (field === 'Brand' && value) {
        loadBrands().then(function () {
          if (slugForBrandName(value)) selectBrand(value);
        });
      } else if (field === 'Brand') {
        beginCatalogueChange();
        clearBrand();
        patch({ internal_listWithoutTemplate: false });
        render();
      }
      if (field === 'Model' && value === MODEL_OTHER_VALUE) {
        beginCatalogueChange();
        clearYear();
        patch({
          Model: '',
          bike_slug_model: '',
          internal_listWithoutTemplate: true,
          internal_assisted_identification_entry_point: 'model',
          internal_assisted_identification: true
        });
        render();
        focusAssistedType();
      } else if (field === 'Model' && value && modelEntryForName(value)) {
        selectModel(value);
      }
      if (field === 'BikeYear' && value === YEAR_NOT_SURE_VALUE) {
        // The generic form binding would otherwise persist the UI-only sentinel
        // into BikeYear after this handler deliberately clears that field.
        event.stopImmediatePropagation();
        selectYearNotSure();
      } else if (field === 'BikeYear' && value && currentState().bike_slug_model) {
        selectYear(value);
      }
      if (field === 'BikeSizing' && value === SIZE_OTHER_VALUE) {
        manualSize('');
        focusSizeOther();
      } else if (field === 'BikeSizing' && value) {
        patch({ BikeSizing: sizeKeyFromLabel(value) });
      }
      if (field === 'bike_data_Rrp') {
        patch({ bike_data_RrpGBP: value });
      }
      if (field === 'condition' || field === 'bike_data_RrpGBP' || field === 'bike_data_Rrp' || field === 'BikeYear') {
        updatePricingInputs();
      }
      if (field === 'ListingPrice') setListingPrice(value, 'seller');
    });

    root.addEventListener('input', function (event) {
      var target = event.target;
      if (target && target.getAttribute && target.getAttribute('data-field') === 'ListingPrice') {
        setListingPrice(target.value, 'seller');
      }
      if (target && target.hasAttribute && target.hasAttribute('data-price-slider')) {
        setListingPrice(target.value, 'seller');
      }
    });

    // PricingSection.tsx adjustPrice(): the ±£10 steppers nudge the asking
    // price, clamp to the £135 minimum, and always mark it seller-edited so a
    // later suggested-price seed never overwrites the seller's choice. The
    // store patch flows back into the visible input via new-listing.js
    // bindControls' subscribe -> writeControl sync.
    root.addEventListener('click', function (event) {
      var target = event.target;
      var assistedExit = target && typeof target.closest === 'function' ? target.closest('[data-assisted-exit]') : null;
      var stepper = target && typeof target.closest === 'function' ? target.closest('[data-price-step]') : null;
      var step;
      if (assistedExit) {
        exitAssistedIdentification();
        return;
      }
      if (!stepper) return;
      step = parseInt(stepper.getAttribute('data-price-step'), 10);
      if (isNaN(step)) return;
      setListingPrice(Math.max(MIN_LISTING_PRICE, parseFloat(currentState().ListingPrice || '0') + step), 'seller');
    });

    // Enter in a reveal-input field commits the name instead of submitting the
    // form, matching the source dialogs' onKeyDown confirm shortcuts.
    root.addEventListener('keydown', function (event) {
      var target = event.target;
      if (event.key !== 'Enter') return;
      if (!target || !target.hasAttribute) return;
      if (target.hasAttribute('data-model-other-input')) {
        event.preventDefault();
        manualModel(target.value);
        return;
      }
      if (target.hasAttribute('data-year-other-input')) {
        event.preventDefault();
        manualYear(target.value);
        return;
      }
      if (target.hasAttribute('data-size-other-input')) {
        event.preventDefault();
        manualSize(target.value);
        return;
      }
      if (!target.hasAttribute('data-brand-other-input')) return;
      event.preventDefault();
      manualBrand(target.value);
    });
  }

  var capability = {
    init: function (options) {
      root = options.root || root;
      store = options.store || store;
      config = options.config || config || {};
      integrations = options.integrations || integrations;
      pricingDefaultAssigned = false;
      if (unsubscribe) unsubscribe();
      if (store && typeof store.subscribe === 'function') {
        unsubscribe = store.subscribe(function (state, changed) {
          if (changed === 'BikeYear' || changed === 'condition' || changed === 'bike_data_Rrp' || changed === 'bike_data_RrpGBP') renderPricing();
          // Catalogue picks already re-render via render() inside selectBrand/selectModel/etc.
          // Manual entry (Model/BikeYear typed directly, no catalogue match) only ever
          // reaches the store through the generic field binding in new-listing.js, so the
          // step visibility needs its own listener for those fields too.
          if (changed === 'Model' || changed === 'BikeYear' || changed === 'condition' || changed === 'BikeType' ||
            changed === 'bike_data_Rrp' || changed === 'bike_data_RrpGBP' || changed === 'internal_listWithoutTemplate' ||
            changed === 'internal_assisted_identification' || changed === 'bike_identification_frame_text' ||
            changed === 'bike_identification_age_range' || changed === 'bike_identification_price_band') {
            renderIdentificationSteps(state);
          }
          // The manual-path BikeType / electric answer also flow through the generic
          // field binding, and they decide which subcategory options are shown.
          if (changed === 'BikeType' || changed === 'internal_electric_bike' || changed === 'bike_data_Subcategory') {
            renderSubcategorySelect(state);
          }
        });
      }
      bindRoot();
      render();
      resumePromise = resumeFromState();
    },
    resume: function () {
      return resumePromise || Promise.resolve(null);
    },
    loadBrands: loadBrands,
    selectBrand: selectBrand,
    selectFamily: selectFamily,
    selectModel: selectModel,
    selectYear: selectYear,
    selectYearNotSure: selectYearNotSure,
    manualBrand: manualBrand,
    manualModel: manualModel,
    manualYear: manualYear,
    manualSize: manualSize,
    updatePricingInputs: updatePricingInputs,
    setListingPrice: setListingPrice,
    brands: function () { return brands.slice(); },
    families: function () { return families.slice(); },
    models: function () { return sortedModels(); },
    years: function () { return years.slice(); },
    sizes: sizeOptions,
    destroy: function () {
      if (unsubscribe) unsubscribe();
      unsubscribe = null;
      boundRoot = null;
      root = null;
      store = null;
      pricingDefaultAssigned = false;
    }
  };

  app.register('bikeData', capability);
})(window, document);
